import { useContext } from 'react';
import { AuthContext } from '@dashboard/context/AuthContext';
import { apiUrl } from '@dashboard/services/env';
import logException from '@dashboard/services/logException';
import request from '@dashboard/services/request';

/**
 * @param {string} id
 * @param {('enable'|'disable')} action
 * @param {string} token
 */
export const toggleLicenseKey = async (id, action, token) => {
  try {
    const key = `/license-keys/${id}/${action}`;

    const response = await request(apiUrl + key, token, {
      method: 'PUT',
    });

    if (!response.data) {
      const error = new Error(response.message || response.error);
      error.response = response;
      throw error;
    }

    return { data: response.data, error: null };
  } catch (error) {
    logException({ message: `Failed to ${action} license key`, error });
    if (error && error.message) {
      return { error: error.message };
    }

    return { error: `Failed to ${action} license key`, data: null };
  }
};

export default function useLicenseKeyQueries() {
  const { token } = useContext(AuthContext);

  return {
    toggleLicenseKey: (id, action) => toggleLicenseKey(id, action, token),
  };
}
